<template>
  <v-container>
    <v-row class="mb-0 mx-0">
      <v-col cols="12">
        <h1 class="justify-left mb-3 mt-0">Edit user</h1>
      </v-col>
    </v-row>
    <v-row class="mt-1 justify-left">
      <v-col cols="12" sm="8" md="5" class="pa-0">
        <v-col cols="12" class="py-0 input-feild-container">
          <v-text-field
            outlined
            color="#293897"
            v-model="userInfo.name"
            @input="$v.userInfo.name.$touch()"
            @change="$v.userInfo.name.$touch()"
            @blur="$v.userInfo.name.$touch()"
            :error-messages="$errorMessages($v.userInfo.name, 'User Name')"
            label="Name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            outlined
            v-model="userInfo.mob"
            type="number"
            minLength="10"
            readonly
            disabled
            @change="$v.userInfo.mob.$touch()"
            @blur="$v.userInfo.mob.$touch()"
            error-messages="Please enter valid mobile number"
            color="#293897"
            label="Mobile Number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            outlined
            v-model="userInfo.email"
            @input="$v.userInfo.email.$touch()"
            @change="$v.userInfo.email.$touch()"
            @blur="$v.userInfo.email.$touch()"
            :error-messages="$errorMessages($v.userInfo.email, 'Email')"
            color="#293897"
            label="Email ID"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          <h3 class="mt-0"><b>Status :</b> {{ userInfo.sts }}</h3>
        </v-col>

        <v-row class="ma-0 mt-1 justify-center mob-fixed">
          <v-col cols="3" class="py-0">
            <v-btn
              outlined
              color="#293897"
              large
              width="100%"
              @click="navigateManageUser"
              class="back-button"
              >Back</v-btn
            >
          </v-col>
          <v-col cols="3" class="py-0">
            <v-btn
              outlined
              color="#293897"
              large
              width="100%"
              class="primary-btn cancel-button"
              @click="performAction('EDIT')"
              >Save</v-btn
            >
          </v-col>
          <v-col cols="3" class="py-0" v-model="userInfo.action">
            <v-btn
              v-if="userInfo.stsCode !== 'DEACTIVE'"
              outlined
              color="#293897"
              large
              :disabled="userInfo.stsCode == 'PENDING'"
              width="100%"
              @click="performAction('DEACTIVATE')"
              :class="userInfo.stsCode !== 'PENDING' ? cancel - button : ''"
              >Deactivate</v-btn
            >
            <v-btn
              v-if="userInfo.stsCode == 'DEACTIVE'"
              outlined
              color="#293897"
              large
              width="100%"
              @click="performAction('ACTIVATE')"
              class="cancel-button"
              >Activate</v-btn
            >
          </v-col>
          <v-col cols="3" class="py-0">
            <v-btn
              outlined
              v-model="userInfo.action"
              value="DELETE"
              width="100%"
              large
              class="delete-button"
              @click="dialog = true"
              >Delete</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- ------------------delete user poup, same can be used for deactivation------ -->
    <v-dialog v-model="dialog" persistent max-width="380">
      <v-card class="text-center pa-5">
        <img src="@/assets/delete-user.svg" class="mt-4" />
        <v-card-title class="title font-weight-bold justify-center">
          Delete User ? </v-card-title
        ><v-card-subtitle
          class="body-1 spiceblue--text py-3 font-weight-medium"
        >
          {{ userInfo.name }}
        </v-card-subtitle>
        <v-card-text class="black--text"
          >Are you sure you want to delete the above user ?</v-card-text
        >
        <v-row class="ma-0 mb-4 justify-center">
          <v-col cols="6" class="py-0">
            <v-btn
              outlined
              color="#293897"
              large
              width="100%"
              class="cancel-button"
              @click="dialog = false"
              >Cancel</v-btn
            >
          </v-col>
          <v-col cols="6" class="py-0">
            <v-btn
              primary
              width="100%"
              depressed
              large
              class="primary-btn submit-button"
              @click="performAction('DELETE')"
              >Delete</v-btn
            >
          </v-col>
        </v-row>
        <div class="text-center">
          <p class="caption mb-0 mt-2">
            *Please Note:* This action can not undone.
          </p>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSuccess" persistent max-width="380">
      <v-card class="text-center pa-5">
        <img src="@/assets/User deleted succesfully.svg" class="mt-4" />
        <v-card-title class="title font-weight-bold justify-center">
          <span v-if="action == 'ACTIVATE'">
            User activated<br />Successfully</span
          >
          <span v-if="action == 'DEACTIVATE'">
            User deactivated<br />Successfully</span
          >
          <span v-if="action == 'DELETE'"> User Deleted<br />Successfully</span>
          <span v-if="action == 'EDIT'"> User updated<br />Successfully</span>
        </v-card-title>
        <v-row class="ma-0 mb-4 justify-center">
          <v-col cols="6" class="py-0">
            <v-btn
              outlined
              color="#293897"
              large
              width="100%"
              class="cancel-button"
              @click="navigateManageUser"
              >Okay</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EditUser from "./editUser.ts";
export default EditUser;
</script>
<style lang="css" src="./editUser.css" scoped />